module.exports = __webpack_public_path__ + "static/media/William Howard Taft (I) - 1912.90828985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/William Howard Taft (I) - 1912.jpg
// module id = 567
// module chunks = 0